"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cycleTimes = cycleTimes;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

function* cycleTimes(iterable, n) {
  while (n--) {
    yield* iterable;
  }
}

var _default = (0, _iterable.iterableCurry)(cycleTimes, {
  validateArgs(args) {
    if (!Array.isArray(args[1])) {
      args[1] = [...args[1]];
    }
  }

});

exports.default = _default;